import { RawSelectorValue, SelectorValue } from "../types";

export const getSelectorList = <V extends RawSelectorValue>(
	arr: readonly V[]
): SelectorValue<V>[] => arr.map(toSelectorValue);

export const toSelectorValue = <V extends RawSelectorValue>(str: V): SelectorValue<V> => ({
	value: str,
	label: String(str),
});

export const toSelectorLabelValue = <V extends RawSelectorValue>(
	label: string,
	value: V
): SelectorValue<V> => ({ label, value });

export const selectorListToValue = <V extends RawSelectorValue>(arr: readonly SelectorValue<V>[]) =>
	arr.map(({ value }) => value);

export const getSelectorValueFromOptions =
	<V extends RawSelectorValue>(options: SelectorValue<V>[]) =>
	(value: V) =>
		options.find((el) => el.value === value);

export const selectorValueToString = (selector: SelectorValue) => String(selector.value);

export const selectorListToString = (arr: readonly SelectorValue[]) =>
	arr.map(selectorValueToString);

export const toRawSelectorValue = (arr: readonly SelectorValue[]) => arr.map(selectorValueToString);
